<template>
  <draggable class="gap-column-sm" ghost-class="menu-rearrange-ghost" :disabled="false" :value="menus"
    @change="onMenuRearrange">
    <!-- <div class="menu-edit">
           <img :src="editActions ? '../icons/edit.svg':'../icons/save.svg'" @click="editMenuTitle" />
        </div>-->

    <MenuCard @select="onMenuSelect" @rename="onEditMenuTitle" :isSelected="currentMenu._id == menu._id" :menu="menu"
      v-for="menu in menus" :key="menu._id" />

    <MenuCard @select="onMenuSelect" @rename="onAddNewMenu" isSelected isPlaceholder v-if="adding_menu.active"
      :menu="{ categories: [], products: [], locales: [], original_locale: '' }" />

    <div class="add-menu-btn qrw-button-text" @click="toggleAddMenuUI(true)" v-if="!adding_menu.active && !rearranging">
      {{ $t("menu_manager.add_menu") }}
    </div>
  </draggable>
</template>

<script>
import SmallButton from "@/components/SmallButton.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import MenuCard from "@/components/menu/MenuCard.vue";

import draggable from "vuedraggable";

export default {
  data () {
    return {
      adding_menu: {
        active: false,
        title: null,
        busy: false,
        last_action: Date.now(),
      },
      editActions: false,
      edit_menu: {
        active: false,
        id: 0,
        title: null,
      },
    };
  },
  props: {
    current: Object,
    edit_menu_id: String,
    rearranging: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    edit_menu_id () {
      this.edit_menu.id = this.edit_menu_id;
      this.edit_menu.active = !!this.edit_menu_id;

      if (this.edit_menu.active) {
        this.edit_menu.title = this.currentMenu.title;

        setTimeout(() => {
          this.$nextTick(() => {
            document.getElementById("editTitleInput").focus();
          });
        }, 150);
      }
    },
  },
  methods: {
    toggleAddMenuUI (show) {
      const now = Date.now();

      if (now - this.adding_menu.last_action <= 300) {
        return;
      }

      this.adding_menu.title = null;
      this.adding_menu.active = show;
      this.adding_menu.last_action = Date.now();
      this.adding_menu.busy = false;

      this.edit_menu.id = 0;
      this.edit_menu.active = false;
      this.$emit("clearEditTitle");
    },
    hideAddMenuUI () {
      this.adding_menu.active = false;
    },
    hasPosterProducts (menu) {
      if (!menu.products) return;
      return !!menu.products.find((p) => !!p.poster_product_id);
    },
    onAddNewMenu (title) {
      this.toggleAddMenuUI(false);

      if (!title || this.adding_menu.busy) return;

      this.adding_menu.busy = true;

      this.$store.dispatch("menu/create", title).then(() => {
        this.$store.dispatch("auditlog/write", {
          type: "menu_create",
          payload: {
            title: this.adding_menu.title,
          },
        });

        this.onMenuSelect(this.menus[this.menus.length - 1]);

        this.toggleAddMenuUI(false);

        this.adding_menu.busy = false;
      });
    },
    onMenuSelect (menu) {
      if (this.rearranging) return;
      if (this.adding_menu.active) return;
      if (this.edit_menu.active) return;
      if (this.currentMenu && this.currentMenu._id == menu._id) {
        this.$emit('edit');
        return;
      }
      this.$store.commit("menu/setCurrentMenu", menu);
      this.$emit("select", menu);
      this.$store.commit("menu/setOutOfSync", false);
    },
    getMenuModes (id) {
      return this.$store.getters["menu/menuModes"](id);
    },
    editMenuTitle () {
      this.editActions = !this.editActions;
    },

    showEditUI (menu) {
      this.edit_menu.active = true;
      this.edit_menu.id = menu._id;
      this.edit_menu.title = menu.title;
    },
    hideEditUI () {
      this.edit_menu.active = false;
      this.edit_menu.id = null;
    },
    onEditMenuTitle (value) {
      this.$store.commit("menu/setMenuTitle", {
        menu_id: this.currentMenu._id,
        title: value
      });
      this.$store.dispatch("menu/save");
      this.hideEditUI();
      this.$emit("clearEditTitle");
    },
    onMenuRearrange (ev) {
      console.log(ev);
      if (ev.moved) {
        this.$store.commit("menu/resetMenusSorting");

        const first = ev.moved.oldIndex;
        const second = ev.moved.newIndex;

        this.$store.commit("menu/rearrangeMenus", {
          first,
          second,
        });
        this.$emit("rearranged");
      }
    },
  },
  computed: {
    menus () {
      return this.$store.state.menu.menus;
    },
    cafe () {
      return this.$store.state.cafe;
    },
    currentMenu () {
      return this.$store.state.menu.current;
    },
    isHotel () {
      return this.$store.getters.isHotel;
    },
  },
  components: {
    SmallButton,
    IQOSActions,
    draggable,
    MenuCard,
  },
};
</script>

<style scoped>
.menu-list-title h3 {
  font-weight: 500;
  color: #ededed;
  font-size: 2.6vh;
  margin-bottom: 0;
}

.menu-edit {
  margin-bottom: 1.1vh;
  text-align: right;
  cursor: pointer;
}

.menu-name-btns {
  position: absolute;
  top: 2.2vh;
  right: 2.2vh;
  z-index: 1;
}

.menu-edit img {
  width: auto;
  height: 3.6vh;
}

.menu-edit-action {
  float: right;
  top: 0;
  margin-right: 2vh;
  position: relative;
}


.card {
  border-radius: 1.2vh;
  border: 0.3vh solid transparent;
  padding: 2.2vh;
  width: 50vh;
  height: 18.8vh;
  background: #e5e5e5;
  overflow: hidden;
  cursor: pointer;
  margin-right: 3.3vh;
}

.current {
  border: 3px solid #129b81;
}

.card h2 {
  font-size: 3.1vh;
  display: block;
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 3vh;
  margin-bottom: 0;
  color: #000000;
}

.languages-list {
  display: flex;
  padding-top: 2vh;
}

.languages-list img {
  width: 2.3vh;
  height: 2.3vh;
  margin-right: 1vh;
}

.card p {
  font-weight: 300;
  font-size: 1.7vh;
  line-height: 1.1;

  color: #a4a3a1;
  margin-bottom: 0;
}

.card-categories-number {
  padding-right: 0.6vh;
}

.card-dishes-number {}

.card-tags {
  display: flex;
  flex-flow: column;
  bottom: 2vh;
  position: absolute;
  right: -0.5vh;
  z-index: 0;
  overflow: hidden;
}

.card-mode-tag:first-child {
  margin-top: 0;
}

.card-mode-tag {
  height: auto;
  min-width: 10.5vh;
  border-radius: 0.6vh;
  font-weight: bold;
  padding: 0.2vh 0.8vh;
  margin: 0.5vh 0 0 0.5vh;
  border: none;
  outline: none;
  border: none;
  outline: none;
  font-size: 1.5vh;
  color: #1d1d1d;
}

.card-mode-tag.i {
  background: #1d1d1d;
  color: #ededed;
}

.card-mode-tag.d {
  background: #cbd9e6;
}

.card-mode-tag.p {
  background: #ffd2a8;
}

.card-mode-tag.preview {
  background: #ffff;
  color: #1d1d1b;
}

.add-menu-btn {
  /* border: 0.3vh solid #908f8d;
  box-sizing: border-box;
  border-radius: 1.5vh;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 50vh;
  height: 18.8vh;
  margin-right: 5.5vh;
  transition: 0.3s;
  cursor: pointer; */
  width: 400px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  border-radius: 8px;
  height: 148px;
  max-width: 400px;
  max-height: 148px;
  min-width: 400px;
  min-height: 148px;
  cursor: pointer;
  color: var(--v1-grey-6-color);
  border: 1px solid var(--v1-grey-6-color);
}

.add-menu-btn:hover {
  color: var(--v1-grey-3-color);
  background: var(--green-6-color);
  border: 1px solid var(--green-6-color);
}

.menu-create {
  border-radius: 1vw;
  background: #1d1d1b;
  width: 100%;
  height: 15vh;
  padding: 1.5vw;
  margin-bottom: 2vw;
}

.menu-create-form {
  display: flex;
}

.menu-create-cancel,
.menu-create-submit {
  width: 4.5vh;
  height: 3.6vh;
  border-radius: 0.35vw;
  border: 0;
  margin-left: 0.6vw;
  cursor: pointer;
}

.menu-create-cancel:hover,
.menu-create-submit:hover {
  outline: none;
}

.menu-create-cancel {
  background: url(../../assets/delete.png) center no-repeat #e2223b;
  background-size: 2vh;
}

.menu-create-submit {
  background: url(../../assets/accept.png) center no-repeat #129b81;
  background-size: 2vh;
}

.menu-title-input {
  background: #1d1d1b;
  border-radius: 0.44vh;
  border: 0;
  padding: 0.4vh 1vh;
  height: auto;
  width: 35vh;
  font-size: 2.3vh;

  color: #ededed;
  outline: none;

  line-height: normal;

  margin-bottom: 0.2vh;
}

.pos-menu-icon {
  width: 2.3vh;
  height: 2.3vh;
  border-radius: 0.3vh;
  position: absolute;
  bottom: 2.2vh;
}

/* @media (max-width: 768px){
  .cards-list {height: 100%; overflow: hidden;}
} */

.menu-rearrange-ghost {
  cursor: grab;
  opacity: 0.8;
}
</style>
